import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ImageGallery from 'react-image-gallery';
require("./image-gallery.css");

const modalRoot = document.getElementById('modal-root');

// Let's create a Modal component that is an abstraction around
// the portal API.
class Modal extends Component {
  constructor(props) {
    super(props);
    // Create a div that we'll render the modal into. Because each
    // Modal component has its own element, we can render multiple
    // modal components into the modal container.
    this.el = document.createElement('div');
  }

  componentDidMount() {
    // Append the element into the DOM on mount. We'll render
    // into the modal container element (see the HTML tab).
    modalRoot.appendChild(this.el);
    document.body.classList.add('modal-open')
    document.querySelector('#mainNav').classList.add('d-none')
  }

  componentWillUnmount() {
    // Remove the element from the DOM when we unmount
    modalRoot.removeChild(this.el);
    document.body.classList.remove('modal-open')
    document.querySelector('#mainNav').classList.remove('d-none')
  }

  render() {
    // Use a portal to render the children into the element
    const product = this.props.product;
    const { title, subTitle, description } = product;
    return ReactDOM.createPortal(
      // Any valid React child: JSX, strings, arrays, etc.
      <div className="portfolio-modal modal fade show modal-react" id="portfolioModal" tabIndex={-1} role="dialog"
        style={{ paddingRight: "15px", display: "block" }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="close-modal" data-dismiss="modal" onClick={this.props.handleHide}>
              <div className="lr">
                <div className="rl" />
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-8 mx-auto">
                  <div className="modal-body">
                    <h2 className="text-uppercase">{title}</h2>
                    <p className="item-intro text-muted">{subTitle}</p>
                    {product.image ? <img className="img-fluid d-block mx-auto" src={product.image} alt={product.title} /> :
                      <ImageGallery lazyLoad style={{marginBottom:"30px"}} items={product.slider} />}
                      <div style={{textAlign: 'center'}}>
                        <div style={{display: 'inline-block', textAlign: 'left'}}>
                        {description.map((describe)=>(<p  style={{lineHeight:1,marginBottom:"10px"}}>{describe}<br/></p>))}
                        </div>
                      </div>
                   { /* {description.map((describe)=>(<p style={{lineHeight:1,marginBottom:"10px",textAlign:"justify"}}>{describe}<br/></p>))}  */}                   
                    {/* <pre>{description.map((describe)=>('\n' + describe))}</pre> */}
                    <ul className="list-inline">
                      {/* <li>Category: {category}</li> */}
                    </ul>
                    <button className="btn btn-primary" data-dismiss="modal" type="button" onClick={this.props.handleHide}>
                      <i className="fa fa-times" />
                      Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >,
      // A DOM element
      this.el,
    );
  }
}
export default Modal;


// WEBPACK FOOTER //
// ./src/components/productModals/Modal.js